<template>
  <div class="w3-container">
    <h3>ადმინისტრატორის პანელი</h3>
    <div class="w3-card-2 w3-light-grey w3-padding">
      <header>
        <h4>კლინიკის დამატება</h4>
      </header>
      <label>კლინიკის დასახელება</label>
      <input class="w3-input" type="text" v-model="newPrisonName">
      <button class="w3-button" @click="addNewPrison">დამატება</button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters} from 'vuex'
import axios from 'axios'

var api_path = "/php_scripts/";
if (process.env.NODE_ENV === 'development') {
  api_path = "http://192.168.1.2/php_scripts/";
} else {
}

export default {
  name: 'adminPage',
  data: function(){
    return {
      newPrisonName: ""
    }
  },
  methods: {
    ...mapActions( {refetchPrisonList: "FETCH_PRISON_DATA"} ),
    addNewPrison(){
      if (this.newPrisonName.length < 1){
        alert("კლინიკის სახელი არ შეიძლება იყოს ცარიელი")
        return
      }
      if (confirm("ნამდვილად გსურთ კლინიკის: \"" + this.newPrisonName + "\" დამატება?")){
        axios({
          method: "POST",
          url: api_path + "insert_prison.php",
          data: {
            prison_name: this.newPrisonName
          }
        })
          .then(response => {
              console.log("response OK");
              console.log(response);
              alert("Save OK");
              this.refetchPrisonList();
              // this.$router.go(-1)
          })
          .catch(function(error) {
              console.log(error);
              // console.log(this);
              alert("Not Saved");
          });
      } else {
        return
      }
    }
  }
}
</script>